import React from "react";
import { Dialog } from "@headlessui/react";
import { useSelector } from "react-redux";
import { IKImage } from "imagekitio-react";
import { getDayDecor } from "../../utils/subscription";
import Progressbar from "../../components/Progressbar";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { getProductPricing } from "../../redux/actions/pricing";
import { useDispatch } from "react-redux";

const CompletionModal = ({
  isModalEnabled,
  setIsModalEnabled,
  type,
  coin_id,
}) => {
  //console.log(type);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userPlan = useSelector(
    (store) =>
      store?.userSubscription.subscriptions?.[
        store?.userSubscription.subscriptions?.length - 1
      ],
  );
  const user_name = useSelector((store) => store?.profileDetails?.name);
  const last_content_played = useSelector(
    (store) => store?.userActivity?.user_last_content_played,
  );
  let [timer, setTimer] = useState();
  let countDownTime = 5;

  const [coinCardData, setCoinCardData] = useState([]);
  const months = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  const product_name = () => {
    if (userPlan?.user_roles_id === 2) return "LearnTube Pro";
    else if (userPlan?.user_roles_id === 3) return "LearnTube Pro+";
    else if (userPlan?.user_roles_id === 4) return "LearnTubeX";
    else return "LearnTube Max";
  };

  useEffect(() => {
    dispatch(
      getProductPricing("coin", "", (successObj) =>
        setCoinCardData(successObj),
      ),
    );
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(countDownTime);
      countDownTime -= 1;

      if (countDownTime < 0) {
        setIsModalEnabled(false);
        clearInterval(interval);
        //console.log("Ding!");
        if (type === "coin") {
          navigate("/pricing?type=coin");
        } else {
          navigate("/pricing");
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);
  console.log("log", coinCardData, coin_id);
  if (type === "coin") {
    return (
      <Dialog
        open={isModalEnabled}
        onClose={() => setIsModalEnabled(!isModalEnabled)}
        as="div"
        className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-y-auto"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
        <Dialog.Title />
        <Dialog.Description />
        <div className="z-10 flex w-4/5 flex-col items-start justify-center rounded-2xl bg-white px-3 py-4 shadow-2xl md:w-3/5  lg:w-[375px]">
          <img
            urlEndpoint="https://img.learntube.ai/public-assets/"
            src={
              "https://img.learntube.ai/public-assets/PRICING/imagenew.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1662738813436"
            }
            transformation={[
              {
                height: "100",
                width: "100",
              },
            ]}
            className=" 
            h-[159px]
            w-[162px]"
          />
          <div className="mt-2 text-2xl font-bold">
            Congratulations,{user_name?.split(" ")?.[0]}!
          </div>
          <div className="mt-2 text-sm">
            Your purchase for{" "}
            <span className="font-bold">
              {coinCardData[parseInt(coin_id) - 7]?.coin_benefits} Coins
            </span>{" "}
            was successful. For the best experience & unlimited access, Upgrade
            to Pro Plans
          </div>

          <div className="mt-4 text-sm text-[#333333]">
            Taking You Back to Previous Screen{" "}
            <span className="font-bold">{timer}s</span>
          </div>
          <Progressbar progress={(timer / 5) * 100} progressColor={"#2BBD13"} />

          <button
            className="mt-4 w-full rounded-3xl border-2 border-pricing_blue bg-pricing_blue px-2  py-2 text-sm text-sm text-white"
            onClick={(event) => {
              if (last_content_played) {
                navigate(last_content_played);
              } else {
                navigate("/courses");
              }
            }}
          >
            Continue Learning
          </button>
        </div>
      </Dialog>
    );
  } else {
    return (
      <Dialog
        open={isModalEnabled}
        onClose={() => setIsModalEnabled(!isModalEnabled)}
        as="div"
        className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-y-auto"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
        <Dialog.Title />
        <Dialog.Description />
        <div className="z-10 flex w-4/5 flex-col items-start justify-center rounded-2xl bg-white px-3 py-4 shadow-2xl md:w-3/5  lg:w-[375px]">
          <img
            urlEndpoint="https://img.learntube.ai/public-assets/"
            src={
              "https://img.learntube.ai/public-assets/PRICING/imagenew.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1662738813436"
            }
            transformation={[
              {
                height: "100",
                width: "100",
              },
            ]}
            className="h-[159px] w-[162px] "
          />
          <div className="mt-2 text-2xl font-bold">
            Congratulations,{user_name?.split(" ")?.[0]}!
          </div>
          <div className="mt-2 text-sm">
            You’ve successfully upgraded to {product_name()}!{" "}
          </div>
          <div className="text-sm ">This plan will expire on:</div>
          <h1 className="mt-2 text-sm font-bold">
            {" "}
            {new Date(userPlan?.expires_at).getDate() +
              getDayDecor(new Date(userPlan?.expires_at).getDate()) +
              " " +
              months[new Date(userPlan?.expires_at).getMonth()] +
              " " +
              new Date(userPlan?.expires_at).getFullYear()}
          </h1>
          <div className="mt-2 text-sm">
            Make the most of it & 10x your career
          </div>
          <div className="mt-4 text-sm text-[#333333]">
            Taking You Back to Previous Screen{" "}
            <span className="font-bold">{timer}s</span>
          </div>
          <Progressbar progress={(timer / 5) * 100} progressColor={"#2BBD13"} />

          <button
            className="mt-4 w-full rounded-3xl border-2 border-pricing_blue bg-pricing_blue px-2  py-2 text-sm text-sm text-white"
            onClick={(event) => {
              if (last_content_played) {
                navigate(last_content_played);
              } else {
                navigate("/courses");
              }
            }}
          >
            Continue Learning
          </button>
        </div>
      </Dialog>
    );
  }
};

export default CompletionModal;
